import { useState, useEffect } from 'react';

const useDeckPreferences = (collectionId, viewMode) => {
  const [preferences, setPreferences] = useState({
    statsExpanded: false,
    sortBy: 'type',
  });

  useEffect(() => {
    if (!collectionId) return;

    const globalKey = `deckPrefs_${collectionId}_global`;
    const viewModeKey = `deckPrefs_${collectionId}_${viewMode}`;

    const globalSaved = localStorage.getItem(globalKey);
    const viewModeSaved = localStorage.getItem(viewModeKey);

    const globalPrefs = globalSaved ? JSON.parse(globalSaved) : { sortBy: 'type' };
    const viewModePrefs = viewModeSaved ? JSON.parse(viewModeSaved) : { statsExpanded: false };

    // Migrate 'cmc' to 'mana_cost' (cmc removed in favor of mana_cost)
    let sortBy = globalPrefs.sortBy || 'type';
    if (sortBy === 'cmc') {
      sortBy = 'mana_cost';
    }

    setPreferences({
      sortBy,
      statsExpanded: viewModePrefs.statsExpanded !== undefined ? viewModePrefs.statsExpanded : false,
    });
  }, [collectionId, viewMode]);

  useEffect(() => {
    if (!collectionId) return;

    const globalKey = `deckPrefs_${collectionId}_global`;
    const viewModeKey = `deckPrefs_${collectionId}_${viewMode}`;

    localStorage.setItem(globalKey, JSON.stringify({ sortBy: preferences.sortBy }));
    localStorage.setItem(viewModeKey, JSON.stringify({ statsExpanded: preferences.statsExpanded }));
  }, [preferences, collectionId, viewMode]);

  const updatePreference = (key, value) => {
    setPreferences((prev) => ({ ...prev, [key]: value }));
  };

  return [preferences, updatePreference];
};

export default useDeckPreferences;
